import {
  webhookCard,
  visitorAccess,
  siteSettings as siteSettingsText,
} from "@modules/locales/default.js"
import { MdLockOpen, MdLockOutline, MdLock } from "react-icons/md"
import { PreviewProtectionType } from "@modules/graphql/types"

export enum SiteSettingsSection {
  Reports = `reports`,
  General = `general`,
  Preview = `preview`,
  Danger = `danger`,
  SiteDetails = `site-details`,
  EnvVars = `env-vars`,
  Webhook = `webhook`,
  ContentLoader = `content-sync`,
  PreviewWebhook = `preview-webhook`,
  BuildsWebhook = `build-webhook`,
  VisitorAccess = `visitor-access`,
  DataSource = `data-source`,
  ManualIntegrations = `manual-integrations`,
  HostingIntegrations = `deploy-targets`,
  Builds = `builds`,
  NotificationDeploys = `notification-deploys`,
  DataSources = `data-sources`,
  Hosting = `hosting`,
  ImageCDN = "image-cdn",
  BuildTypes = `build-types`,
  BuildFeatures = `build-features`,
  GatsbyHosting = `gatsby-hosting`,
  Domains = `domains`,
  LogDrains = `logDrains`,
  DataLayer = `data-layer`,
  ContentHub = `content-hub`,
}

export const SiteSettingsSectionLabel: Record<SiteSettingsSection, string> = {
  [SiteSettingsSection.Reports]: `Reports`,
  [SiteSettingsSection.General]: `General`,
  [SiteSettingsSection.Preview]: siteSettingsText.headers.preview,
  [SiteSettingsSection.Danger]: `Danger zone`,
  [SiteSettingsSection.SiteDetails]: `Site details`,
  [SiteSettingsSection.EnvVars]: siteSettingsText.headers.environmentVariables,
  [SiteSettingsSection.Webhook]: `Webhook`,
  [SiteSettingsSection.PreviewWebhook]: webhookCard.previewWebhook,
  [SiteSettingsSection.ContentLoader]: `Content sync`,
  [SiteSettingsSection.BuildsWebhook]: webhookCard.buildsWebhook,
  [SiteSettingsSection.VisitorAccess]: visitorAccess.visitorAccess,
  [SiteSettingsSection.DataSource]: `Data source`,
  [SiteSettingsSection.ManualIntegrations]: `Manual`,
  [SiteSettingsSection.HostingIntegrations]:
    siteSettingsText.headers.hostingIntegrations,
  [SiteSettingsSection.Builds]: `Builds`,
  [SiteSettingsSection.NotificationDeploys]: `Outgoing notifications`,
  [SiteSettingsSection.DataSources]: siteSettingsText.headers.dataSources,
  [SiteSettingsSection.Hosting]: siteSettingsText.headers.hosting,
  [SiteSettingsSection.ImageCDN]: `Images`,
  [SiteSettingsSection.BuildTypes]: siteSettingsText.headers.buildTypes,
  [SiteSettingsSection.BuildFeatures]: siteSettingsText.headers.buildFeatures,
  [SiteSettingsSection.Domains]: siteSettingsText.headers.domains,
  [SiteSettingsSection.GatsbyHosting]: siteSettingsText.headers.GatsbyHosting,
  [SiteSettingsSection.LogDrains]: siteSettingsText.headers.logDrains,
  [SiteSettingsSection.DataLayer]: siteSettingsText.headers.dataLayer,
  [SiteSettingsSection.ContentHub]: siteSettingsText.headers.contentHub,
}

export type VisitorAccessOption = {
  value: PreviewProtectionType
  label: string
  description: string
  descriptionSelected?: string
  icon: React.ComponentType<React.ComponentPropsWithoutRef<"svg">>
}

export const visitorAccessOptions: VisitorAccessOption[] = [
  {
    value: PreviewProtectionType.Public,
    label: visitorAccess.public,
    description: visitorAccess.anyoneCanVisit,
    icon: MdLockOpen,
  },
  {
    value: PreviewProtectionType.Password,
    label: visitorAccess.passwordProtected,
    description: visitorAccess.visitorHasToKnowPassword,
    icon: MdLockOutline,
  },
  {
    value: PreviewProtectionType.CloudAuth,
    label: visitorAccess.logInRequired,
    description: visitorAccess.visitorMustHaveGatsbyAccount,
    icon: MdLock,
  },
  {
    value: PreviewProtectionType.IpRanges,
    label: visitorAccess.ipRangeProtected,
    description: visitorAccess.visitorMustHaveIp,
    descriptionSelected: visitorAccess.visitorMustHaveIpSelected,
    icon: MdLock,
  },
]
